import React, { useEffect, useMemo, useState } from "react";

function STAAircraft({
  callsign,
  anchor,
  eta,
  // hasRadarTrack = true,
  type = "L",
  isFrozen = true,
  delay
}) {
  let shouldFill = false;
  let color = "#009897";

  switch (type) {
    case "H":
      shouldFill = true;
  }

  if (!isFrozen) {
    color = "#CCCC00";
  }

  // if (!hasRadarTrack) {
  //   color = "#FF9832";
  // }

  return (
    <>
      <text
        x="28"
        y={95 - anchor}
        fill={color}
        textAnchor="start"
        alignmentBaseline="central"
        fontSize={1.1}
        // fontWeight="bold"
      >
        {callsign}
      </text>
      <text
        x="31.5"
        y={95 - anchor}
        fill="#00FD98"
        textAnchor="start"
        alignmentBaseline="central"
        fontSize={1.1}
        // fontWeight="bold"
      >
        {delay}
      </text>
      {(type === "S" || type === "5") && (
        <>
          <path
            d={`M 28.0 ${95 - anchor - 0.1}, 27.6 ${95 - anchor - 0.1}, 27.6 ${95 - anchor + 0.1}, 28.0 ${95 - anchor + 0.1}`}
            stroke={color}
            fill={color}
            strokeWidth={0.07}
          />
          {type === "5" && (
            <path
              d={`M 27.87 ${95 - anchor - 0.25}, 27.73 ${95 - anchor - 0.25}, 27.73 ${95 - anchor + 0.25}, 27.87 ${95 - anchor + 0.25} Z`}
              stroke={color}
              fill={"#000"}
              strokeWidth={0.05}
            />
          )}
        </>
      )}
      {type !== "S" && type !== "5" && (
        <path
          d={`M 28.0 ${95 - anchor - 0.3}, 27.65 ${95 - anchor}, 28.0 ${95 - anchor + 0.3}`}
          stroke={color}
          fill={shouldFill ? color : "none"}
          strokeWidth={0.07}
        />
      )}
      {/* {Math.abs(anchor - eta) > 0.5 && ( */}
        <path
          d={`M 27.5 ${95 - anchor}, 26.75 ${95 - eta}`}
          fill="transparent"
          stroke={color}
          strokeWidth={0.07}
        />
      {/* )} */}
    </>
  );
}

export default STAAircraft;